export default {
  "nav": "_nav_su47dq",
  "nav-wrapper": "_nav-wrapper_su47dq",
  "nav-item": "_nav-item_su47dq",
  "icon": "_icon_su47dq"
};